import type { IApiOrganizationUserRole } from '~/lib/api/modules/Organizations';

export type IParsedOrganizationUserRoles = {
  atLeastMember?: boolean;
  atLeastAdmin?: boolean;
  atLeastOwner?: boolean;
};

export const parseOrganizationUserRoles = (
  roles: Array<IApiOrganizationUserRole>,
): IParsedOrganizationUserRoles => {
  if (roles.includes('owner')) {
    return {
      atLeastMember: true,
      atLeastAdmin: true,
      atLeastOwner: true,
    };
  }

  if (roles.includes('admin')) {
    return {
      atLeastMember: true,
      atLeastAdmin: true,
    };
  }

  if (roles.includes('member')) {
    return {
      atLeastMember: true,
    };
  }

  return {};
};
